import { useNavigate } from "react-router-dom";
import { Shell, Card } from "../components/Layout";
import { Button } from "../components/ui/button";

export default function CentroHome() {
  const navigate = useNavigate();
  return (
    <Shell
      accent="centro"
      title="Centro de Estudios"
      subtitle="Apoyo escolar en grupos reducidos, de Primaria a Bachillerato."
      testid="centro-home-page"
    >
      <div className="grid gap-8 lg:grid-cols-3">
        <Card>
          <h2 className="font-head text-2xl font-medium">Es mi primera vez</h2>
          <p className="mt-3 text-lg text-ink-700">
            Le acompañamos paso a paso: datos del alumno, elección del horario y confirmación de la
            matrícula.
          </p>
          <Button data-testid="start-matricula-btn" onClick={() => navigate("/centro/matricula")}
            className="mt-6 h-14 w-full bg-centro text-lg hover:bg-centro-hover">
            Matricular a un alumno
          </Button>
        </Card>
        <Card>
          <h2 className="font-head text-2xl font-medium">Ya estamos matriculados</h2>
          <p className="mt-3 text-lg text-ink-700">
            Acceda a su cuenta para consultar el horario, comunicar una ausencia o registrar los
            exámenes.
          </p>
          <Button data-testid="centro-login-btn" variant="outline" onClick={() => navigate("/entrar")}
            className="mt-6 h-14 w-full text-lg">
            Acceder a mi cuenta
          </Button>
        </Card>
        <Card>
          <h2 className="font-head text-2xl font-medium">Horario y disponibilidad</h2>
          <p className="mt-3 text-lg text-ink-700">
            Consulte las franjas de cada etapa y su disponibilidad.
          </p>
          <Button data-testid="centro-schedule-btn" variant="outline" onClick={() => navigate("/centro/horario")}
            className="mt-6 h-14 w-full text-lg">
            Consultar el horario semanal
          </Button>
        </Card>
      </div>

      <div className="mt-8">
        <Button data-testid="centro-policy-btn" variant="outline" onClick={() => navigate("/centro/politica")}
          className="h-14 text-lg">
          Consultar la política del centro
        </Button>
      </div>
    </Shell>
  );
}
